import React, { useEffect, useRef, useState } from "react";
import { toastConfig } from "../../constants/constant";
import { Service } from "../../services/service";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setAddButtonDisabled,
  setButtonAction,
  setHeader,
  setUpdateButtonDisabled,
} from "../../reduxSlices/headerSlice";
import CommonDialog from "../dialog/CommonDialog";
import ContentLoader from "../loader/ContentLoader";
import styles from "./AppealCategories.module.css";
import { Box } from "@mui/material";
import CustomAutocomplete from "../autocomplete/Autocomplete";
import {
  getAnnualGivingOutput,
  getAnnualGivingTranslation,
  getAppealCategoryTranslation,
  getChannelTranslation,
  getFundPurposeTranslation,
  getPhilanthropicFundTranslation,
  getProgramTranslation,
  getTranslationsOutput,
} from "../../reduxSlices/translationSlice";
import history from "../../helpers/history";
import { CustomTextField, keysHaveValue } from "../../helpers/helper";
import AddCustomFieldDialog from "../dialog/AddCustomFieldDialog";
const service = new Service();

const AppealCategories = () => {
  const unblockRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openCustomField, setOpenCustomField] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [blockNavOpen, setBlockNavOpen] = useState(false);
  const [currentPath, setCurrentPath] = useState("");
  const [block, setBlock] = useState(true);
  const [loader, setLoader] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [formState, setFormState] = useState({
    organizationId: "",
    transalationId: "",
    transType: "",
    translationValue: [
      {
        id: "",
        outputId: "",
        columnValue: "",
        titleValue: "",
        customFieldCategory: "",
      },
    ],
    isTranslationAdded: true,
  });
  const headerData = useSelector((state) => state?.header);
  const buttonAction = headerData?.buttonAction;
  const transalationId = localStorage.getItem("transalationId");
  const transType = localStorage.getItem("transType");
  const selectedOrg = localStorage.getItem("selectedOrg");
  const parseOrg = JSON.parse(selectedOrg);
  const organisationId = parseOrg.organizationId;
  const loading = useSelector((state) => state.translation.loading);
  const allTranslationsOutput = useSelector(
    (state) => state?.translation?.allTranslationsOutput
  );
  const allChannelTranslation = useSelector(
    (state) => state?.translation?.allChannelTranslation?.data?.translationValue
  );
  const isTranslationAdded = useSelector(
    (state) => state.translation.isTranslationAdded
  );
  const page = localStorage.getItem("page");
  const mainTitle = localStorage.getItem("mainTitle");
  const title = localStorage.getItem("title");
  const subTitle = localStorage.getItem("subTitle");
  const placeholder =
    transalationId === "1"
      ? "channel"
      : transalationId === "2"
      ? "program"
      : transalationId === "3"
      ? "appeal"
      : transalationId === "18"
      ? "annaul giving"
      : "fund purpose";
  const columnValue =
    transType === "opt1a"
      ? "Appeal ID"
      : transType === "opt1b"
      ? "Appeal Category"
      : transType === "opt2a"
      ? "Campaign ID"
      : transType === "opt2b"
      ? "Campaign Category"
      : "Dollar Threshold";

  useEffect(() => {
    console.log("formStateformState", formState);
  }, [formState]);

  const handleClose = () => {
    setOpenCustomField(false);
    setDeleteOpen(false);
    setBlockNavOpen(false);
  };

  const handleInputFocus = () => {
    setIsClicked(true);
  };

  const getTranslationsOutputData = async () => {
    const obj = {
      translationId: transalationId || "",
      organisationId: organisationId || "",
      transType: transType || "",
    };
    if (transalationId === "18") {
      await dispatch(getAnnualGivingOutput(obj));
    } else {
      await dispatch(getTranslationsOutput(obj));
    }
  };

  const getChannelTranslationData = async () => {
    const obj = {
      translationId: transalationId || "",
      organisationId: organisationId || "",
      transType: transType || "",
    };
    if (transalationId === "1") {
      await dispatch(getChannelTranslation(obj));
    } else if (transalationId === "2") {
      await dispatch(getProgramTranslation(obj));
    } else if (transalationId === "3") {
      await dispatch(getAppealCategoryTranslation(obj));
    } else if (transalationId === "18") {
      await dispatch(getAnnualGivingTranslation(obj));
    } else if (transalationId === "8") {
      await dispatch(getFundPurposeTranslation(obj));
    } else {
      await dispatch(getPhilanthropicFundTranslation(obj));
    }
  };

  useEffect(() => {
    getTranslationsOutputData();
    getChannelTranslationData();
  }, [dispatch, transalationId, transType]);

  useEffect(() => {
    if (allChannelTranslation) {
      const modifiedData = allChannelTranslation?.map((item, i) => {
        const filterOutputData = allTranslationsOutput.find(
          (e) => e.outputId === item.outputId
        );
        const outputData = filterOutputData ? filterOutputData : 0;
        const isEmpty = item.outputId === 0 && isTranslationAdded;
        return { ...item, outputId: outputData, isEmpty: isEmpty };
      });
      const annualGivingData = isTranslationAdded
        ? allChannelTranslation?.map((item, i) => {
            const outputData =
              transType === "opt3"
                ? item?.columnValue
                : allTranslationsOutput.find((e) => e.id === item.id);
            return {
              ...item,
              titleValue: columnValue,
              columnValue: outputData,
            };
          })
        : [
            {
              id: "",
              outputId: "",
              columnValue: "",
              titleValue: columnValue,
              customFieldCategory: "",
            },
          ];
      setFormState({
        ...formState,
        organizationId: organisationId,
        transalationId: transalationId,
        transType: transType,
        translationValue:
          transalationId === "18" ? [...annualGivingData] : [...modifiedData],
      });
    }
  }, [allChannelTranslation]);

  useEffect(() => {
    if (block) {
      unblockRef.current = history.block((tx) => {
        let url = tx.location.pathname;
        setCurrentPath(url);
        setBlockNavOpen(true);
        return false;
      });
    }
    return () => {
      if (typeof unblock === "function") {
        unblockRef.current && unblockRef.current();
      }
    };
  }, [block]);

  useEffect(() => {
    if (!isClicked) return;
    const keysToCheck = [transalationId === "18" ? "columnValue" : "outputId"];
    const allKeysHaveValue = formState?.translationValue?.every((obj) =>
      keysHaveValue(obj, keysToCheck)
    );
    if (!isTranslationAdded) {
      dispatch(setAddButtonDisabled(allKeysHaveValue));
    } else {
      dispatch(setUpdateButtonDisabled(allKeysHaveValue));
    }
  }, [formState?.translationValue, isClicked]);

  const onConfirmNav = () => {
    if (unblockRef) {
      unblockRef.current();
    }
    setBlockNavOpen(false);
    history.push(currentPath);
  };

  useEffect(() => {
    dispatch(
      setHeader({
        page: page || "",
        mainTitle: mainTitle || "",
        title: title || "",
        subTitle: subTitle || "",
      })
    );
    dispatch(setAddButtonDisabled(false));
    dispatch(setUpdateButtonDisabled(false));
  }, []);

  useEffect(() => {
    if (
      buttonAction.page === "appeal-categories" ||
      buttonAction.page === "campaign-categories" ||
      buttonAction.page === "campaign-id" ||
      buttonAction.page === "dollar-threshold" ||
      buttonAction.page === "fund-categories" ||
      buttonAction.page === "fund-types" ||
      buttonAction.page === "appeal-id"
    ) {
      if (buttonAction.action === "add" || buttonAction.action === "update") {
        handleSubmit();
      }
      if (buttonAction.action === "cancel") {
        handleGoBack();
      }
      if (buttonAction.action === "delete") {
        setDeleteOpen(true);
      }
      if (buttonAction.action === "addCustomField") {
        setOpenCustomField(true);
      }
    }
    dispatch(
      setButtonAction({
        page: "",
        action: "",
      })
    );
  }, [buttonAction.page, buttonAction.action]);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleSubmit = () => {
    createTranslation();
  };

  const handleDelete = () => {
    deleteTranslation();
    setDeleteOpen(false);
  };

  const createTranslation = async () => {
    setLoader(true);
    let url = `/api/Translations/${
      transalationId === "1"
        ? "AddChannelTranslation"
        : transalationId === "2"
        ? "AddProgramTranslation"
        : transalationId === "3"
        ? "AddAppealCategoryTranslation"
        : transalationId === "18"
        ? "AddAnnualGivingTranslation"
        : transalationId === "8"
        ? "AddFundPurposeTranslation"
        : "AddPhilanthropicFundTranslation"
    }`;
    const user_token = localStorage.getItem("bb_access_token");
    const translationData = prepareTranslationData();
    const formData = JSON.stringify(translationData);
    try {
      let data = await service.newPostApi(url, formData, user_token);
      let resp = data.data;
      console.log("resp", resp);
      if (resp?.data && resp?.success) {
        setLoader(false);
        toast.success(`Your data has been recorded`, {
          ...toastConfig,
          style: {
            backgroundColor: "#4a67ad",
          },
        });
        getChannelTranslationData();
        setIsClicked(false);
        dispatch(setUpdateButtonDisabled(false));
      } else {
        setLoader(false);
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      setLoader(false);
      toast.error(err?.message, toastConfig);
    }
  };

  const deleteTranslation = async () => {
    setLoader(true);
    let url = `/api/Translations/RemoveExistingTranslation?translationId=${transalationId}&organizationId=${organisationId}`;
    const user_token = localStorage.getItem("bb_access_token");
    try {
      let response = await service.newDeleteApi(url, {}, user_token);
      let resp = response.data;
      console.log("resp", resp);
      if (resp?.data && resp?.success) {
        setLoader(false);
        toast.success(`Translation settings has been deleted`, {
          ...toastConfig,
          style: {
            backgroundColor: "#4a67ad",
          },
        });
        getChannelTranslationData();
        dispatch(setAddButtonDisabled(false));
        dispatch(setUpdateButtonDisabled(false));
      } else {
        setLoader(false);
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      setLoader(false);
      toast.error(err?.message, toastConfig);
    }
  };

  const prepareTranslationData = () => {
    if (transalationId === "18") {
      return {
        ...formState,
        translationValue: formState.translationValue?.map(
          ({ titleValue, ...item }) => {
            return {
              ...item,
              outputId: 73,
              columnValue:
                transType === "opt3"
                  ? item?.columnValue
                  : item?.columnValue?.value,
            };
          }
        ),
      };
    } else {
      return {
        ...formState,
        translationValue: formState.translationValue?.map(
          ({ isEmpty, ...item }) => {
            return {
              ...item,
              outputId: item?.outputId?.outputId ? item?.outputId?.outputId : 0,
            };
          }
        ),
      };
    }
  };

  const prepareData = prepareTranslationData();

  console.log("prepareTranslationData", prepareData);

  const getOrgLabel = (option) => option?.value;

  const handleAutoCompleteChange = (id, value) => {
    const modifiedData = formState?.translationValue?.map((obj, i) => {
      if (obj.id === id) {
        const isEmpty = value.outputId === 0 && isTranslationAdded;
        return { ...obj, outputId: value, isEmpty: isEmpty };
      }
      return obj;
    });
    const annualGivingData = {
      id: value?.id,
      outputId: "",
      columnValue: value,
      titleValue: columnValue,
      customFieldCategory: "",
    };
    setFormState((prevState) => ({
      ...prevState,
      translationValue:
        transalationId === "18" ? [annualGivingData] : [...modifiedData],
    }));
  };

  const handleChange = (e, item) => {
    const { value } = e.target;
    const annualGivingData = {
      id: 0,
      outputId: "",
      columnValue: value,
      titleValue: columnValue,
      customFieldCategory: "",
    };
    setFormState((prevState) => ({
      ...prevState,
      translationValue: [annualGivingData],
    }));
  };

  if (loading || loader) return <ContentLoader />;

  return (
    <>
      {formState?.translationValue &&
        formState?.translationValue?.map((item, i) => (
          <Box
            key={i}
            className={`${styles.mainContainer} ${
              item?.isEmpty ? styles.emptyfield : ""
            }`}
          >
            <Box className={styles.container}>
              <Box className={styles.contentDiv}>
                {transalationId === "18" ? item?.titleValue : item?.columnValue}
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "520px",
              }}
            >
              {transalationId === "18" && transType === "opt3" ? (
                <CustomTextField
                  placeholder="0.00"
                  sx={{
                    width: "100%",
                  }}
                  id="outlined-basic"
                  variant="outlined"
                  type="number"
                  name="expense"
                  value={item?.columnValue}
                  onChange={(e) => handleChange(e, item)}
                  onFocus={handleInputFocus}
                  InputProps={{
                    startAdornment: <span style={{ marginRight: 5 }}>$</span>,
                  }}
                />
              ) : (
                <CustomAutocomplete
                  options={allTranslationsOutput}
                  value={
                    transalationId === "18" ? item?.columnValue : item?.outputId
                  }
                  onChange={(e, value) => {
                    if (value === null) {
                      value = {
                        outputId: 0,
                        value: "",
                      };
                    }
                    handleAutoCompleteChange(item.id, value);
                  }}
                  getOptionLabel={getOrgLabel}
                  onFocus={handleInputFocus}
                  placeholder={`Select the ${placeholder} for the corresponding category...`}
                />
              )}
            </Box>
          </Box>
        ))}

      <CommonDialog
        open={blockNavOpen}
        setOpen={setBlockNavOpen}
        handleCancel={handleClose}
        handleDone={onConfirmNav}
        title="All changes will be lost"
        subTitle="Are you sure you want to discard changes?"
        leftButtonText="Cancel"
        rightButtonText="Discard"
      />
      <CommonDialog
        open={deleteOpen}
        setOpen={setDeleteOpen}
        handleCancel={handleClose}
        handleDone={handleDelete}
        title="Confirm delete"
        subTitle="Are you sure you want to delete these settings? You’ll not be able to reverse this action."
        leftButtonText="Cancel"
        rightButtonText="Delete"
      />
      <AddCustomFieldDialog
        open={openCustomField}
        setOpen={setOpenCustomField}
        handleDone={handleClose}
        title="Add Organisation Specific Program"
        leftButtonText="Cancel"
        rightButtonText="Submit"
        getTranslationsOutputData={getTranslationsOutputData}
      />
    </>
  );
};

export default AppealCategories;
